import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import HeadshotComponent from './headshot';
import ConversationSettingsComponent from './conversation_settings';
import ParticipantDetailsContainer from '../containers/participant_details_container';

const ConversationDetails = ({ display, conversationId, users, close, archive }) => {

  const initialHighlightedParticipant = users.length === 1 ? users[0] : null;

  const [displaySettingsDropdown, setDisplaySettingsDropdown] = useState(false);
  const [highlightedParticipant, setHighlightedParticipant] = useState(initialHighlightedParticipant);

  const pageClickRef = useRef(handlePageClick);
  useEffect(() => { pageClickRef.current = handlePageClick; });

  useEffect(() => {
    const cb = e => pageClickRef.current(e);
    document.addEventListener('mouseup', cb);

    return () => { document.removeEventListener('mouseup', handlePageClick) };
  }, []);

  useEffect(() => {
    if (users.length > 1) {
      resetParticipantDetails();
    } else {
      setHighlightedParticipant(users[0]);
    }
  }, [conversationId]);

  const handlePageClick = e => {
    if (!displaySettingsDropdown) { return; }
    const isConversationSettings = e.target.classList.contains('conversation-settings');
    const inConversationSettings = $(e.target).parents('.conversation-settings').length;
    if (isConversationSettings || inConversationSettings) { return; }

    setDisplaySettingsDropdown(false);
    return false;
  };

  const userList = users.map(user => {
    return (
      <li key={user.id} className="card-container">
        <div className="voray-entity-card card-circle pointer" onClick={() => { setHighlightedParticipant(user) }}>
          <div className="image">
            <img src={user.headShotImage} alt={user.displayName} />
          </div>
          <div className="flex-grow-1 text">
            <span className="title t3 w3" title={user.displayName}>{user.displayName}</span>
            <span className="subtitle">{user.companyTitle}</span>
          </div>
        </div>
      </li>
    );
  });

  const resetParticipantDetails = () => { setHighlightedParticipant(null); }

  let toggleSettings          = true,
      closeParticipantDetails = false,
      xsSmCloseButton         = true;

  if (users.length > 1 && highlightedParticipant) {
    closeParticipantDetails = true;
    toggleSettings = false;
    xsSmCloseButton = false;
  }

  return (
    <aside className={`conversation-details display-flex col-md-3 col-xs-12 col-md-offset-${display ? '9' : '12'} col-xs-offset-${display ? '0' : '12'}`}>
      <div className="row display-flex">
        <div className="details-nav display-flex pt-5">

          { xsSmCloseButton &&
            <i className="visible-xs visible-sm fa fa-chevron-left fa-lg mr-10" onClick={close}></i>
          }

          { toggleSettings &&
            <i className={`fa fa-cog fa-lg ${displaySettingsDropdown ? 'text-default ' : ''}pointer`}
              onClick={() => { setDisplaySettingsDropdown(!displaySettingsDropdown) }}>
            </i>
          }

          { closeParticipantDetails &&
            <i className="fa fa-times fa-lg pointer" onClick={resetParticipantDetails}></i>
          }
        </div>

        <div className="conversation-details-contents">
          <div className="t4 w3 nav-dropdown-header">Participants</div>
          <ul className="participant-list list-unstyled">
            {userList}
          </ul>
        </div>
      </div>

      <ConversationSettingsComponent
        display={displaySettingsDropdown}
        conversationId={conversationId}
        archive={archive} />

      <ParticipantDetailsContainer user={highlightedParticipant} />

    </aside>
  );
};

ConversationDetails.propTypes = {
  display: PropTypes.bool.isRequired,
  users: PropTypes.array.isRequired
};

export default ConversationDetails;
